import styled, { keyframes } from "styled-components";
import { ReactComponent as CartSvg } from "../../assets/icons/cartSvg.svg";
import { ReactComponent as FavoriteSvg } from "../../assets/icons/favoriteSvg.svg";
import { ReactComponent as EmptyProfilePhotoSvg } from "../../assets/icons/profile-photo.svg";
import { ReactComponent as LogoGift } from "../../assets/icons/gift-empty.svg";
import { ReactComponent as LogoIcon } from "../../assets/icons/logo-original.svg";
import { ReactComponent as Menu } from "../../assets/icons/aaaa.svg";
import { ReactComponent as ChevronDown } from "../../assets/icons/chevronDown.svg";

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

export const ChevronDownIcon = styled(ChevronDown)`
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  rotate: ${(props) => (props.$active ? "-180deg" : "0deg")};
  min-width: 2rem;
  max-width: 2rem;
  min-height: 2rem;
  max-height: 2rem;
  position: absolute;
  display: none;
  right: 2rem;

  path {
    stroke-width: 3px;
  }

  @media (max-width: 870px) {
    display: flex;
  }
  @media (max-width: 600px) {
    right: 1.5rem;
  }
`;

export const Logo = styled(LogoIcon)`
  cursor: pointer;
  width: auto;
  height: 65px;
  path {
    fill: #484888;
  }
  @media (max-width: 870px) {
    display: none;
  }
`;
export const StyledLogo = styled(LogoIcon)`
  cursor: pointer;

  path {
    fill: #484888;
  }
  display: none;
  @media (max-width: 870px) {
    display: flex;
    height: 43px;
  }
  @media (max-width: 380px) {
    height: 30px;
    width: auto;
  }
  @media (max-width: 330px) {
    height: 25px;
  }
`;

export const EmptyProfilePhoto = styled(EmptyProfilePhotoSvg)`
  cursor: pointer;
  height: 3.5rem;
  width: auto;
  @media (max-width: 1300px) {
    height: 3rem;
  }
`;
export const ProfilePhoto = styled.img`
  min-width: 3.5rem;
  min-height: 3.5rem;
  max-width: 3.5rem;
  max-height: 3.5rem;
  cursor: pointer;
  border-radius: 50%;
  object-fit: cover;
  @media (max-width: 1300px) {
    min-width: 3rem;
    min-height: 3rem;
    max-width: 3rem;
    max-height: 3rem;
  }
`;
export const ProfilePicEmpty = styled.div`
  min-width: 3.5rem;
  min-height: 3.5rem;
  max-width: 3.5rem;
  max-height: 3.5rem;
  cursor: pointer;
  border-radius: 50%;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #484888;
  @media (max-width: 1300px) {
    min-width: 3rem;
    min-height: 3rem;
    max-width: 3rem;
    max-height: 3rem;
  }
`;
export const LogoGiftIcon = styled(LogoGift)`
  height: auto;
  margin-bottom: -3px;
  margin-left: -0.05px;
  width: 1.7rem;
  path {
    stroke-width: 0.7px;
  }
`;

export const FavoriteIcon = styled(FavoriteSvg)`
  cursor: pointer;
  min-width: 3.5rem;
  min-height: 3.5rem;
  max-width: 3.5rem;
  max-height: 3.5rem;
  @media (max-width: 1300px) {
    min-width: 3rem;
    min-height: 3rem;
    max-width: 3rem;
    max-height: 3rem;
  }
`;

export const CartIcon = styled(CartSvg)`
  cursor: pointer;
  min-width: 3.5rem;
  min-height: 3.5rem;
  max-width: 3.5rem;
  max-height: 3.5rem;
  @media (max-width: 1300px) {
    min-width: 3rem;
    min-height: 3rem;
    max-width: 3rem;
    max-height: 3rem;
  }
`;

export const Image = styled.img`
  cursor: pointer;
  min-width: 3.5rem;
  min-height: 3.5rem;
  max-width: 3.5rem;
  max-height: 3.5rem;
  border-radius: 50%;
  user-select: none;
  @media (max-width: 1300px) {
    min-width: 3rem;
    min-height: 3rem;
    max-width: 3rem;
    max-height: 3rem;
  }
`;
export const CounterDiv = styled.div`
  display: flex;
  pointer-events: none;
  padding: 2px;
  max-width: 1.4rem;
  max-height: 1.4rem;
  min-width: 1.4rem;
  min-height: 1.4rem;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: #ea435d;
  position: absolute;
  right: -5px;
  top: 50%;
  transform: translateY(-50%);
  user-select: none;
`;
export const Icon = styled.div`
  position: relative;
  cursor: pointer;
`;
export const Count = styled.span`
  color: #fff;
  font-family: "Avenir-Medium";
  font-size: 1.3rem;
  font-weight: "400";
  line-height: 1.8rem; /* 139.535% */
`;

export const HeaderContainer = styled.div`
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.11);
  width: 100%;
  height: ${(p) => (p.$hideCategories ? "unset" : "14rem")};
  transition: all 0.3s ease-in-out;
  position: relative;

  @media (max-width: 870px) {
    height: ${(props) =>
      props.$hideCategories ? "unset" : props.$active ? "100px" : "80px"};
    padding: ${(p) => (p.$hideCategories ? "0" : "0rem 2rem")};
  }
  @media (max-width: 380px) {
    height: ${(props) =>
      props.$hideCategories ? "unset" : props.$active ? "100px" : "65px"};
  }
`;
export const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  /* max-width: 150rem; */
  gap: 2rem;
  width: 100%;
  position: ${(p) => (p.$hideCategories ? "relative" : "absolute")};
  padding: ${(p) => (p.$hideCategories ? "20px" : "0rem 5rem")};
  top: ${(p) => (p.$hideCategories ? "unset" : "2rem")};
  @media (max-width: 1500px) {
    max-width: 100%;
  }
  @media (max-width: 870px) {
    padding: ${(p) => (p.$hideCategories ? "10px 20px" : "0rem 5rem")};
    padding-right: ${(p) => (p.$hideCategories ? "20px" : "5rem")};
    padding-left: ${(p) => (p.$hideCategories ? "20px" : "2rem")};
  }
  @media (max-width: 600px) {
    padding-left: ${(p) => (p.$hideCategories ? "20px" : "3.5rem")};
  }
`;

export const StyledCategoriesRow = styled.div`
  display: none;
  flex-direction: row;
  align-items: center;
  gap: 2rem;

  padding: 0 2rem;
  z-index: 10;
  left: 0;

  right: 0;
  position: absolute;
  bottom: 1rem;
  justify-content: ${(props) =>
    props.$flexStart ? "flex-start" : "space-between"};
  width: 100%;
  overflow-x: auto;
  animation: ${(props) => (props.$active ? fadeIn : fadeOut)} 0.2s ease-in-out;

  &&::-webkit-scrollbar {
    height: 2px;
  }

  &&::-webkit-scrollbar-thumb {
    border-radius: 3rem;
    background-color: #484888;
  }

  &&::-webkit-scrollbar-track {
    background-color: transparent;
  }

  @media (max-width: 870px) {
    display: flex !important;
  }
`;

export const CategoriesRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  gap: 2rem;
  justify-content: ${(props) =>
    props.$flexStart ? "flex-start" : "space-between"};
  width: 100%;
  overflow-x: auto;
  /* overflow: visible; */
  height: 3rem;

  &&::-webkit-scrollbar {
    height: 3px;
  }

  &&::-webkit-scrollbar-thumb {
    border-radius: 3rem;
    background-color: #48488855;
  }

  &&::-webkit-scrollbar-track {
    background-color: transparent;
  }
  @media (max-width: 1300px) {
    height: unset;
  }
  @media (max-width: 870px) {
    display: none;
  }
`;

export const StyledHeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2rem;
  justify-content: ${(props) =>
    props.$flexStart ? "flex-start" : "space-between"};
  width: 100%;
  overflow-x: auto;

  &&::-webkit-scrollbar {
    height: 3px;
  }

  &&::-webkit-scrollbar-thumb {
    border-radius: 3rem;
    background-color: #48488855;
  }

  &&::-webkit-scrollbar-track {
    background-color: transparent;
  }
  @media (max-width: 330px) {
    gap: 1.5rem;
  }
`;
export const LogoRow = styled.div`
  display: none;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  @media (max-width: 870px) {
    display: flex;
  }
`;
export const MenuIcon = styled(Menu)`
  cursor: pointer;
  width: 2.4rem;
  height: 2.4rem;

  stroke: #484888;
`;

export const HeaderRightSide = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  width: fit-content;
  gap: 3rem;
  @media (max-width: 600px) {
    gap: 1.5rem;
  }
`;

export const Button = styled.button`
  outline: none;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: #484888;
  border-radius: 1rem;
  padding: 0.5rem 2rem;
  width: fit-content;

  color: #fff;
  font-family: "Avenir-Medium";
  font-size: 1.9rem;
  font-weight: "400";
  line-height: 3rem;
  transition: all 0.3s ease-in-out;
  user-select: none;

  &:active {
    filter: brightness(90%);
    scale: 0.975;
  }
  @media (max-width: 870px) {
    display: none;
  }
`;

export const Category = styled.span`
  color: ${(props) =>
    props.$red ? "#A80000" : props.$active ? "#484888" : "#423f3f"};
  font-family: "Avenir-Medium";
  font-weight: "400";
  cursor: pointer;
  text-decoration: ${(props) => (props.$active ? "underline" : "none")};
  font-size: 2rem;
  line-height: 2.6rem; /* 137.5% */
  white-space: nowrap;
  user-select: none;
  &:hover {
    color: #484888;
  }
  @media (max-width: 1300px) {
    font-size: 1.6rem;
    line-height: 2.2rem; /* 137.5% */
  }
`;
export const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  height: 2.2rem;
  gap: 2rem;
  flex-direction: row;
`;
